import Cookies from 'js-cookie'
import ky, { type BeforeErrorHook, type BeforeRequestHook } from 'ky'
import { authTokenQueryOptions } from './auth-token-query'
import { isAuthError } from './is-auth-error'
import { queryClient } from './query-client'

// @ts-ignore
window.Cookies = Cookies

if (!import.meta.env.VITE_BASE_API_URL) {
  throw new Error('VITE_BASE_API_URL is not defined')
}

const refreshAuthHook: BeforeRequestHook = async (request, options) => {
  if (options.requireAuth) {
    await queryClient.fetchQuery(authTokenQueryOptions)
  }

  return request
}

const invalidateAuthHook: BeforeErrorHook = async error => {
  if (isAuthError(error)) {
    Cookies.remove('accessToken')
  }

  return error
}

export const httpClient = ky.create({
  prefixUrl: import.meta.env.VITE_BASE_API_URL,
  hooks: {
    beforeRequest: [refreshAuthHook],
    beforeError: [invalidateAuthHook],
  },
  credentials: 'include',
})
